import React from 'react';
import { liteClient as searchClient } from 'algoliasearch/lite';
import { baseConfig } from '../../config/algolia';
import { InstantSearch, Configure } from 'react-instantsearch';
import PageFlyHits from './PageFlyHits';
import { InsightsMiddleware } from '../../utils/algolia/InsightsMiddleware';
import { ProductClient } from '@jbhi-fi/apis/src/algolia/ProductClient';

const { app_id, product_families_api_key, product_families_index } = baseConfig;
//PNP-1873 - sku has been passed from pagefly.js where element with data-pagefly-sku attribute exists.
const PageFlyContainer = ({ skuNodes }) => {
  const algoliaSearchClient = searchClient(
    app_id ?? '',
    product_families_api_key ?? '',
    ProductClient.getAlogliaCache(app_id)
  );
  const indexName = product_families_index;
  const hitsPerPage = window.Jbhifi.pageflyHitsLimit ?? 100;

  //PNP-1873 - render using indices specified through to PageFlyHits with React Instant search
  return (
    <InstantSearch searchClient={algoliaSearchClient} indexName={indexName}>
      <InsightsMiddleware />
      <Configure
        clickAnalytics
        hitsPerPage={Math.min(hitsPerPage, 500)}
        query=""
        filters={
          skuNodes
            .map(node => `sku: ${node.dataset.pageflySku} OR skus: ${node.dataset.pageflySku} OR `)
            .join('')
            .slice(0, -4) + ' AND (price > 0 AND product_published = 1 AND availability.displayProduct = 1)'
        }
        distinct
      />
      <PageFlyHits skuNodes={skuNodes} />
    </InstantSearch>
  );
};

export default PageFlyContainer;
